/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Invite.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import CancelAction from './CancelAction/view.js'
import Company from './Company/logic.js'
import EffectiveDate from './EffectiveDate/logic.js'
import Email from './Email/logic.js'
import ExistingUsers from './ExistingUsers/logic.js'
import ExpiryDate from './ExpiryDate/view.js'
import FirstName from './FirstName/logic.js'
import InviteAction from './InviteAction/view.js'
import LastName from './LastName/logic.js'
import ModalHeader from 'DesignSystem/ModalHeader/view.js'
import PhoneNumber from './PhoneNumber/view.js'
import PlanStartDate from './PlanStartDate/view.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import { css } from "emotion"
Company.displayName = 'CompanyLogic'
EffectiveDate.displayName = 'EffectiveDateLogic'
Email.displayName = 'EmailLogic'
ExistingUsers.displayName = 'ExistingUsersLogic'
FirstName.displayName = 'FirstNameLogic'
LastName.displayName = 'LastNameLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
overflowY: "auto",
paddingTop: 0,
paddingBottom: 60,
paddingLeft: 50,
paddingRight: 50})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row",
marginTop: 20,
  opacity: 'var(--opacity)'})
styles.Horizontal4 = css({label: 'Horizontal4',
  flexDirection: "row",
marginTop: 20})
styles.Vertical1 = css({label: 'Vertical1',
  opacity: 'var(--opacity)'})

export default function Invite({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isExistingUser,
viewPath= "/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<ModalHeader
 data-testid="Invite.ModalHeader"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/ModalHeader`}
 text="Invite an employee"
>
{childProps => (
<React.Fragment>
<InviteAction
{...childProps}
 data-testid="Invite.InviteAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/InviteAction`}
/>
<CancelAction
{...childProps}
 data-testid="Invite.CancelAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/CancelAction`}
/>
</React.Fragment>
)}
</ModalHeader>
<div
 data-testid="Invite.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
 text="Enrollment has not occurred. The employee will go through the full enrollment process and make the decision to enroll or waive coverage."
 className={`views-block ${styles.Vertical}`}
>
<SubTitle
 data-testid="Invite.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/SubTitle`}
 marginTop={30}
 text="Select the company"
/>
<div
 data-testid="Invite.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
 className={`views-block ${styles.Horizontal}`}
>
<Company
 data-testid="Invite.Company"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/Company`}
/>
</div>
<SubTitle
 data-testid="Invite.SubTitle:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Benefit effective date"
/>
<div
 data-testid="Invite.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
 className={`views-block ${styles.Horizontal1}`}
>
<EffectiveDate
 data-testid="Invite.EffectiveDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/EffectiveDate`}
/>
<PlanStartDate
 data-testid="Invite.PlanStartDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/PlanStartDate`}
/>
<ExpiryDate
 data-testid="Invite.ExpiryDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/ExpiryDate`}
/>
</div>
<SubTitle
 data-testid="Invite.SubTitle:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Select an existing user"
/>
<div
 data-testid="Invite.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
 className={`views-block ${styles.Horizontal2}`}
>
<ExistingUsers
 data-testid="Invite.ExistingUsers"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/ExistingUsers`}
/>
</div>
<SubTitle
 data-testid="Invite.SubTitle:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/SubTitle`}
 text="Or create new employee"
 marginTop={50}
 opacity={isExistingUser ? 0.5 : 1}
/>
<div
 data-testid="Invite.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
 style={{'--opacity': isExistingUser ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal3}`}
>
<FirstName
 data-testid="Invite.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/FirstName`}
/>
<LastName
 data-testid="Invite.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/LastName`}
/>
</div>
<div
 data-testid="Invite.Horizontal:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
 className={`views-block ${styles.Horizontal4}`}
>
<PhoneNumber
 data-testid="Invite.PhoneNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/PhoneNumber`}
/>
<div
 data-testid="Invite.Vertical:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
 style={{'--opacity': isExistingUser ? 0.5 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<Email
 data-testid="Invite.Email"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Invite"
viewPath={`${viewPath}/Email`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}